import { render } from "./foodByType.vue?vue&type=template&id=f79ab30c"
import script from "./foodByType.vue?vue&type=script&lang=js"
export * from "./foodByType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__